import React from "react";
import JobPostCard from "./JobPostCard";

const JobListPanel = ({ jobs, onSelect }) => {
    return (
        <>
{jobs?.map((job) => (
    <div className="relative group gradient-effect space-y-4">
      <div className="hover-effect group-hover:opacity-30 transition-opacity duration-300" />
        <JobPostCard
            key={job.jpo_id}                     
            recordData={job}
            onClick={() => onSelect(job)}
        />
    </div>

))}
        </>
    );
};

export default JobListPanel;